module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Underworld-Awakening.386634a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Underworld-Awakening.jpg
// module id = 6Qzd
// module chunks = 0